import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function getAllRequestor(reqData) {
  try {
    const res = await post(`${URL.filterRequestedByOptions}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
